import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): any {
    if (typeof value === 'string') {
      if (value.length > 1) {
        return (
          value.substring(0, 1).toUpperCase() + value.substring(1).toLowerCase()
        );
      }
    } else {
      return value;
    }
  }
}
